module.exports = __webpack_public_path__ + "pc/img/swiper_bg_08.fee3372c.jpg";